import { render, staticRenderFns } from "./bannerModfiyPage.vue?vue&type=template&id=2280398b&scoped=true&"
import script from "./bannerModfiyPage.vue?vue&type=script&lang=js&"
export * from "./bannerModfiyPage.vue?vue&type=script&lang=js&"
import style0 from "./bannerModfiyPage.vue?vue&type=style&index=0&id=2280398b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2280398b",
  null
  
)

export default component.exports